import classes from './RealEstate.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Link} from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';


const RealEstate = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

     const { t } = useTranslation();
        
    const title = t('realEstate.title')
    const description = t('realEstate.text', {returnObjects: true})

    const blackBlocks = t('realEstate.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('realEstate.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('realEstate.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('realEstate.benefitBlocks', {returnObjects: true})

    const stories = t('realEstate.stories', {returnObjects: true})

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('realEstate.Faq.left', {returnObjects: true}),
        right: t('realEstate.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    Real Estate IT Solutions & Property Management Software | Goteco
                </title>
                <meta
                    name="description"
                    content="Optimize property management, leasing, and investment operations with scalable real estate IT solutions. Improve tenant experience, automate workflows, and maximize ROI with Goteco."
                />
                <link rel="canonical" href="https://go-te.co/industries/real-estate" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={700}/>

            <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                <div>
                    <h3>{t('realEstate.blackBlocksTitle')}</h3>
                    <p>{t('realEstate.blackBlocksText')}</p>
                    <p>{t('realEstate.blackBlocksText2')}</p>
                </div>
                <div className={classes.blocks}>
                    {blackBlocks.map(({text, icon}) => (<BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                <div>
                    <h2>{t('realEstate.challengesBlocksTitle')}</h2>
                </div>

                <div>
                    {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                     text={text} key={title}/>)}
                </div>
            </section>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('realEstate.solutionsBlocksTitle')}</h2>
                </div>

                <div>
                    {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                        <img alt={title} src={require(`./media/${image}`)}/>
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('realEstate.benefitBlocksTitle')}</h2>
                    <p>{t('realEstate.benefitBlocksText')}</p>
                </div>

                <div>
                    {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text} key={title}/>)}
                </div>
            </section>

            <section className={"section--dark-gray " + classes['stories']}>
                <h2>{t('realEstate.storiesTitle')}</h2>
                <div className={classes.blocks}>
                    {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                 key={title}/>)}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('realEstate.useCase')}</h2>
                        <div className={classes.text}>
                            <img src={eRoadImg} alt="Healthcare use case"/>
                            <p>{t('realEstate.useCaseSubtitle')}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('realEstate.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>
                            {t('realEstate.useCaseButton')}
                        </Link>
                    </div>
                </div>
                <img className={classes.img} src={eRoadImg} alt="Healthcare system"/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard 
                        title={t('realEstate.formCard.title')}
                        message={t('realEstate.formCard.message')}
                        buttonText={t('realEstate.formCard.buttonText')}
                        labels={t('realEstate.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('realEstate.Faq.title')} questions={questions}/>
            </section>
        </main>
        </>
    );
};

export default RealEstate;